export const es = {
  $vuetify: {
    // C
    close: 'Cerrar',
    chooseOption: 'Elegir una opción',
    collectionTitle: 'Version del producto',

    // P
    projectHasBeenSaved: 'El proyecto ha sido guardado',
    projectCodeSummary: 'Utilice el siguiente código para reabrirlo y continuar más tarde',

    // Q
    qrcodeSummary: 'Escanee el código QR con su smartphone para ver el producto en realidad aumentada',

    // S
    seeInAR: 'Ver en casa',

  },
}
